import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { RecipesComponent } from '../recipes.component';
import { CloseConfirmComponent } from '../../close-confirm/close-confirm.component';

@Component({
  selector: 'vex-new-recipe',
  templateUrl: './new-recipe.component.html',
  styleUrls: ['./new-recipe.component.scss',
    '../../../../../node_modules/quill/dist/quill.snow.css',
    '../../../../@vex/styles/partials/plugins/quill/_quill.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewRecipeComponent implements OnInit {
  form: UntypedFormGroup;
  formLang: any;
  iconFormFlag: any;
  flags = {
    en: 'flag:united-states',
    it: 'flag:italy'
  };
  category = [
    { key: 'colazione', description: 'Colazione' },
    { key: 'merenda', description: 'Merenda' },
    { key: 'pranzo', description: 'Pranzo' },
    { key: 'cena', description: 'Cena' }
  ];
  availableTags: string[] = ['Senza glutine', 'Senza lattosio', 'Vegetariana', 'Vegana', 'Salato', 'Dolce'];
  selectedFile: File | null = null;
  ingredients = [];
  allIngredients = [];
  selectedIngredients: any[] = [];
  showCreateIngredient: boolean = false;
  units = [
    { en: "liters", it: "litri" },
    { en: "deciliters", it: "decilitri" },
    { en: "centiliters", it: "centilitri" },
    { en: "milliliters", it: "millilitri" },
    { en: "cup", it: "tazza" },
    { en: "glass", it: "bicchiere" },
    { en: "teacup", it: "tazzina" },
    { en: "tablespoon", it: "cucchiaio" },
    { en: "teaspoon", it: "cucchiaino" },
    { en: "fluid ounce", it: "oncia liquida" },
    { en: "pint", it: "pinta" },
    { en: "grams", it: "grammi" },
    { en: "kilograms", it: "chilogrammi" },
    { en: "milligrams", it: "milligrammi" },
    { en: "ounce", it: "oncia" },
    { en: "pounds", it: "libbre" },
    { en: "a.n.", it: "q.b." },
    { en: "pinch", it: "pizzico" },
    { en: "handful", it: "manciata" },
    { en: "a knob", it: "una noce" },
    { en: "a slice", it: "una fettina" },
    { en: "half cup", it: "mezza tazza" },
    { en: "nr", it: "nr" }
  ];
  currentLang: string;

  constructor(private fb: UntypedFormBuilder, public translate: TranslateService, public guiService: GuiService, public restService: RestService, private dialogRef: MatDialogRef<RecipesComponent>, public dialog: MatDialog) {
    this.currentLang = translate.currentLang || translate.getDefaultLang();
   }

  ngOnInit(): void {
    this.changeFormLanguage(this.translate.currentLang);
    this.getIngredients();
    this.form = this.fb.group({
      nome_it: [null, Validators.required],
      nome_en: [null, Validators.required],
      category: [null, Validators.required],
      desc_it: [null, Validators.required],
      desc_en: [null, Validators.required],
      tags: [],
      image: null,
      ingredients: null,
      ingredient_name_it: null,
      ingredient_name_en: null,
      ingredient_unit: null,
    })
  }

  changeFormLanguage(lang) {
    this.iconFormFlag = this.flags[lang];
    this.formLang = lang;
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  submit() {
    const formData = new FormData();

    const i18nTitle = {
      it: this.form.get('nome_it')?.value,
      en: this.form.get('nome_en')?.value
    };
    const i18nPreparation = {
      it: this.form.get('desc_it')?.value,
      en: this.form.get('desc_en')?.value
    };
    const ingredientsIds = this.selectedIngredients.map((ingredient: any) => ingredient._id);

    formData.append('i18nTitle', JSON.stringify(i18nTitle));
    formData.append('i18nPreparation', JSON.stringify(i18nPreparation));
    formData.append('category', this.form.get('category')?.value);

    const tags = this.form.get('tags')?.value;
    if (tags && tags.length > 0) {
      tags.forEach((tag: string) => {
        formData.append('tags[]', tag);
      });
    }

    if (ingredientsIds && ingredientsIds.length > 0) {
      ingredientsIds.forEach((ingredient: string) => {
        formData.append('ingredients[]', ingredient);
      });
    }

    if (this.selectedFile) {
      formData.append('image', this.selectedFile, this.selectedFile.name);
    }

    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postServiceUserId('node', '/create-recipe', formData, this.guiService.userLogged.user.id).subscribe((ris) => {
      this.dialogRef.close('done');
    })
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
      this.form.patchValue({
        image: this.selectedFile
      });
    }
  }

  onOptionSelected(event: any): void {
    const selectedItem = event.option.value;
    if (!this.selectedIngredients.includes(selectedItem)) {
      this.selectedIngredients.push(selectedItem);
    }
    this.form.get('ingredients').setValue('');
  }

  searchIng(){
    if(this.form.value.ingredients && this.form.value.ingredients.length > 2){
      this.ingredients = this.allIngredients.filter(element => element.i18nName[this.translate.currentLang].toLowerCase().includes(this.form.value.ingredients.toLowerCase()))
    }else{
      this.ingredients = this.allIngredients;
    }
  }

  getIngredients(){
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('node', '/ingredients-list', {userId: this.guiService.userLogged.user.id}).subscribe((ris) => {
      this.ingredients = ris;
      this.allIngredients = ris;
      this.guiService.showSpinner = false
    })
  }

  addIngredient(){
    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      i18nName: {
        "en": this.form.value.ingredient_name_en,
        "it": this.form.value.ingredient_name_it
      },
      unit: this.form.value.ingredient_unit
    }
    this.restService.postServiceUserId('node', '/create-ingredients',param, this.guiService.userLogged.user.id).subscribe((ris) => {
      this.allIngredients.push(ris);
      this.form.get('ingredients').setValue('');
      this.form.get('ingredient_name_it').setValue('');
      this.form.get('ingredient_name_en').setValue('');
      this.form.get('ingredient_unit').setValue('');
      this.showCreateIngredient = false
      this.guiService.showSpinner = false
    })
  }

  removeSelected(item: any): void {
    this.selectedIngredients = this.selectedIngredients.filter(i => i !== item);
  }

  moveIngredient(index: number, direction: 'left' | 'right'): void {
    const newIndex = direction === 'left' ? index - 1 : index + 1;
    [this.selectedIngredients[index], this.selectedIngredients[newIndex]] = [this.selectedIngredients[newIndex], this.selectedIngredients[index]];
  }
}
